export default __webpack_public_path__ + "static/media/marketContext_loading.233b58d3.png";